import { render, staticRenderFns } from "./externalDetails.vue?vue&type=template&id=098e6882&scoped=true&"
import script from "./externalDetails.vue?vue&type=script&lang=js&"
export * from "./externalDetails.vue?vue&type=script&lang=js&"
import style0 from "./externalDetails.vue?vue&type=style&index=0&id=098e6882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e6882",
  null
  
)

export default component.exports